import {
  avatar_kayi_common_0_cover,
  avatar_kayi_common_0_detail,
  avatar_kayi_common_1_cover,
  avatar_kayi_common_1_detail,
  avatar_kayi_common_2_cover,
  avatar_kayi_common_2_detail,
  avatar_kayi_common_3_cover,
  avatar_kayi_common_3_detail,
  avatar_kayi_common_4_cover,
  avatar_kayi_common_4_detail,
  avatar_kayi_common_5_cover,
  avatar_kayi_common_5_detail,
  avatar_kayi_common_6_cover,
  avatar_kayi_common_6_detail,
  avatar_kayi_common_7_cover,
  avatar_kayi_common_7_detail,
  avatar_kayi_common_8_cover,
  avatar_kayi_common_8_detail,
  avatar_kayi_common_9_cover,
  avatar_kayi_common_9_detail,
  avatar_kayi_sketch_0_cover,
  avatar_kayi_sketch_0_detail,
  avatar_kayi_sketch_1_cover,
  avatar_kayi_sketch_1_detail,
  avatar_mp_kayi_female_0_v2_cover,
  avatar_mp_kayi_female_0_v2_detail,
  avatar_mp_kayi_female_0_v3_cover,
  avatar_mp_kayi_female_0_v3_detail,
  avatar_mp_kayi_female_0_v4_cover,
  avatar_mp_kayi_female_0_v4_detail,
  avatar_mp_kayi_male_0_v2_cover,
  avatar_mp_kayi_male_0_v2_detail,
  avatar_mp_kayi_male_0_v3_cover,
  avatar_mp_kayi_male_0_v3_detail,
  avatar_mp_kayi_male_0_v4_cover,
  avatar_mp_kayi_male_0_v4_detail,
  avatar_special_engin_0_cover,
  avatar_special_engin_0_detail,
  avatar_special_halloween_0_cover,
  avatar_special_halloween_0_detail,
} from "../images/marketplace/avatars";
import {
  silverLCover,
  silverLDetail,
  silverLtag,
  silverMCover,
  silverMDetail,
  silverMtag,
  silverSCover,
  silverSDetail,
  silverStag,
  silverXlCover,
  silverXlDetail,
  silverXltag,
  silverXsCover,
  silverXsDetail,
  silverXstag,
} from "../images/marketplace";
import {
  avatar_kayi_common_0,
  avatar_kayi_common_1,
  avatar_kayi_common_2,
  avatar_kayi_common_3,
  avatar_kayi_common_4,
  avatar_kayi_common_5,
  avatar_kayi_common_6,
  avatar_kayi_common_7,
  avatar_kayi_common_8,
  avatar_kayi_common_9,
  avatar_kayi_default_0,
  avatar_kayi_sketch_0,
  avatar_kayi_sketch_1,
  avatar_mp_kayi_female_0_v2,
  avatar_mp_kayi_female_0_v3,
  avatar_mp_kayi_female_0_v4,
  avatar_mp_kayi_male_0_v2,
  avatar_mp_kayi_male_0_v3,
  avatar_mp_kayi_male_0_v4,
  avatar_special_engin_0,
  avatar_special_halloween_0,
} from "../images/avatars";
import { SkuStatus, SkuType } from "../types/Sku";

export const silverPackagesAssetsMappings = [
  {
    _id: "silver-xl-pack",
    coverImg: silverXlCover,
    tagImg: silverXltag,
    detailImg: silverXlDetail,
  },
  {
    _id: "silver-l-pack",
    coverImg: silverLCover,
    tagImg: silverLtag,
    detailImg: silverLDetail,
  },
  {
    _id: "silver-m-pack",
    coverImg: silverMCover,
    tagImg: silverMtag,
    detailImg: silverMDetail,
  },
  {
    _id: "silver-s-pack",
    coverImg: silverSCover,
    tagImg: silverStag,
    detailImg: silverSDetail,
  },
  {
    _id: "silver-xs-pack",
    coverImg: silverXsCover,
    tagImg: silverXstag,
    detailImg: silverXsDetail,
  },
];

export const avatarsAssetMapping = [
  {
    _id: "avatar-kayi-common-0",
    coverImg: avatar_kayi_common_0_cover,
    avatarImg: avatar_kayi_common_0,
    detailImg: avatar_kayi_common_0_detail,
  },
  {
    _id: "avatar-kayi-common-1",
    coverImg: avatar_kayi_common_1_cover,
    avatarImg: avatar_kayi_common_1,
    detailImg: avatar_kayi_common_1_detail,
  },
  {
    _id: "avatar-kayi-common-2",
    coverImg: avatar_kayi_common_2_cover,
    avatarImg: avatar_kayi_common_2,
    detailImg: avatar_kayi_common_2_detail,
  },
  {
    _id: "avatar-kayi-common-3",
    coverImg: avatar_kayi_common_3_cover,
    avatarImg: avatar_kayi_common_3,
    detailImg: avatar_kayi_common_3_detail,
  },
  {
    _id: "avatar-kayi-common-4",
    coverImg: avatar_kayi_common_4_cover,
    avatarImg: avatar_kayi_common_4,
    detailImg: avatar_kayi_common_4_detail,
  },
  {
    _id: "avatar-kayi-common-5",
    coverImg: avatar_kayi_common_5_cover,
    avatarImg: avatar_kayi_common_5,
    detailImg: avatar_kayi_common_5_detail,
  },
  {
    _id: "avatar-kayi-common-6",
    coverImg: avatar_kayi_common_6_cover,
    avatarImg: avatar_kayi_common_6,
    detailImg: avatar_kayi_common_6_detail,
  },
  {
    _id: "avatar-kayi-common-7",
    coverImg: avatar_kayi_common_7_cover,
    avatarImg: avatar_kayi_common_7,
    detailImg: avatar_kayi_common_7_detail,
  },
  {
    _id: "avatar-kayi-common-8",
    coverImg: avatar_kayi_common_8_cover,
    avatarImg: avatar_kayi_common_8,
    detailImg: avatar_kayi_common_8_detail,
  },
  {
    _id: "avatar-kayi-common-9",
    coverImg: avatar_kayi_common_9_cover,
    avatarImg: avatar_kayi_common_9,
    detailImg: avatar_kayi_common_9_detail,
  },
  {
    _id: "avatar-kayi-sketch-0",
    coverImg: avatar_kayi_sketch_0_cover,
    avatarImg: avatar_kayi_sketch_0,
    detailImg: avatar_kayi_sketch_0_detail,
  },
  {
    _id: "avatar-kayi-sketch-1",
    coverImg: avatar_kayi_sketch_1_cover,
    avatarImg: avatar_kayi_sketch_1,
    detailImg: avatar_kayi_sketch_1_detail,
  },
  {
    _id: "avatar-mp-kayi-female-0-v2",
    coverImg: avatar_mp_kayi_female_0_v2_cover,
    avatarImg: avatar_mp_kayi_female_0_v2,
    detailImg: avatar_mp_kayi_female_0_v2_detail,
  },
  {
    _id: "avatar-mp-kayi-female-0-v3",
    coverImg: avatar_mp_kayi_female_0_v3_cover,
    avatarImg: avatar_mp_kayi_female_0_v3,
    detailImg: avatar_mp_kayi_female_0_v3_detail,
  },
  {
    _id: "avatar-mp-kayi-female-0-v4",
    coverImg: avatar_mp_kayi_female_0_v4_cover,
    avatarImg: avatar_mp_kayi_female_0_v4,
    detailImg: avatar_mp_kayi_female_0_v4_detail,
  },
  {
    _id: "avatar-mp-kayi-male-0-v2",
    coverImg: avatar_mp_kayi_male_0_v2_cover,
    avatarImg: avatar_mp_kayi_male_0_v2,
    detailImg: avatar_mp_kayi_male_0_v2_detail,
  },
  {
    _id: "avatar-mp-kayi-male-0-v3",
    coverImg: avatar_mp_kayi_male_0_v3_cover,
    avatarImg: avatar_mp_kayi_male_0_v3,
    detailImg: avatar_mp_kayi_male_0_v3_detail,
  },
  {
    _id: "avatar-mp-kayi-male-0-v4",
    coverImg: avatar_mp_kayi_male_0_v4_cover,
    avatarImg: avatar_mp_kayi_male_0_v4,
    detailImg: avatar_mp_kayi_male_0_v4_detail,
  },
  {
    _id: "avatar-special-engin-0",
    coverImg: avatar_special_engin_0_cover,
    avatarImg: avatar_special_engin_0,
    detailImg: avatar_special_engin_0_detail,
  },
  {
    headingColor: "orange", //supply if change name and item name color
    _id: "avatar-special-halloween-0",
    coverImg: avatar_special_halloween_0_cover,
    detailImg: avatar_special_halloween_0_detail,
    avatarImg: avatar_special_halloween_0,
    descriptionColor: "orange", //supply if change description color
    description: `<span>Introducing a chilling Halloween avatar:</span> 
        <span>The Scarecrow Warrior!</span>
        <span>Step into a world where medieval warriors meet Halloween horrors. 
        Wear the eerie scarecrow face and conquer the realm with unmatched style and fear. 
        Available for a limited time only – embrace the darkness today!</span>`, //supply if change desc, it can be html or string
  },
  {
    _id: "avatar-kayi-default-0",
    isDefault: true,
    type: SkuType.AVATAR,
    status: SkuStatus.OWNED, //preowned
    avatarImg: avatar_kayi_default_0,
  }
];
